import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

/**
 * Abaixo do breakpoint `md` do tema, a shell deixa de reservar espaço fixo para
 * a sidebar: ela passa a operar como overlay acionado por um botão na navbar,
 * em vez de ocupar uma coluna permanente ao lado do conteúdo.
 */
export function useIsMobile(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('md'));
}
